import React from 'react'
import HeroHeader from '../layout/HeroHeader'
import OurServices from '../components/OurServices'

const Services = () => {
  return (
    <>
        
    <HeroHeader title={'Our Services'}/>
    <OurServices />
    </>
  )
}

export default Services